<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.payments', 2),
                        href: null,
                    },
                ]"
            >
            </SmartBreadcrumbs>
        </template>
        <div class="mt-3 flex justify-end space-x-1">
            <AppButton element="InertiaLink" :href="meta.links.payments_general_index">
                {{ $t('messages.student_payment_list') }}
            </AppButton>
        </div>

        <div>
            <NavLinks :links="meta.navLinks.schoolYears" />
        </div>

        <GroupSelector :grade-levels="gradeLevels" :user-grade-levels="user_grade_levels" class="mt-5">
            <template v-slot:default="{ filteredGradeLevels }">
                <div class="mb-2" v-for="gradeLevel in filteredGradeLevels" :key="gradeLevel.id">
                    <AppButton
                        element="inertia-link"
                        v-for="group in gradeLevel.groups"
                        :href="group.url"
                        :key="group.id"
                        desired-action
                        class="mr-2"
                    >
                        {{ group.name }}
                    </AppButton>
                </div>
            </template>
        </GroupSelector>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import GroupSelector from '@/components/GroupSelector.vue';
import AppButton from '@/components/AppButton.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        NavLinks,
        PanelPage,
        GroupSelector,
        AppButton,
    },
    layout: Layout,
    name: 'Show',
    props: ['gradeLevels', 'user_grade_levels', 'meta'],
};
</script>
